
import React from 'react';
import { Row, Dropdown, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/taskfilterbar.css'
import Store from '../store/Store';

const TaskFilterOnly = ({ order, setOrder, isDoneFilter, setIsDoneFilter }) => {
  const { user } = Store.getState(); 
  return (
        <Row>
          <Dropdown className="custom-dd">
            <Dropdown.Toggle className={`button ${isDoneFilter ? 'active-filter' : ''}`} id="dropdown-custom" variant="">
              <FontAwesomeIcon icon={'gear'} /> Szűrés              
            </Dropdown.Toggle>

            <Dropdown.Menu className='p-2'>
              <Dropdown.Item onClick={() => setOrder(1)} className={`fake-radio ${order === 1 ? 'selected' : ''}`}>
                Kezdés időpontja szerint növekvő
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setOrder(0)} className={`fake-radio ${order === 0 ? 'selected' : ''}`}>
                Kezdés időpontja szerint csökkenő
              </Dropdown.Item>
              {user?.permissions?.includes('pwaViewCompletedTasks') && (
                  <Dropdown.Item>
                    <Form.Check
                      type="checkbox"
                      label='Elvégzett feladatok elrejtése'
                      checked={isDoneFilter}
                      onChange={() => setIsDoneFilter(prev => !prev)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Row>
  );
};

export default TaskFilterOnly;
